module.exports = __webpack_public_path__ + "img/members-right-ck.0343ca3d.png";